import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import withWidth, { SMALL } from 'material-ui/utils/withWidth';
import React from 'react';
import styles from '../../styles/form';
import * as dateHelper from './date-helpers';

// Material UI is smart and doesn't render whitespace strings
//   so we gotta be smart and render unicode empty strings!
const emptyLabel = '\u00A0';

const defaultFieldNames = {
  day: 'Day',
  month: 'Month',
  year: 'Year'
};

const defaultMaxWidths = {
  day: '19%',
  month: '49%',
  year: '29%'
};

/**
 * Break a date down into its three components
 *
 * @param {*} date
 */
const structureDate = (date) => {
  if (typeof date === 'number') {
    date = new Date(date);
  }
  return {
    day: date ? date.getDate() : undefined,
    month: date ? date.getMonth() : undefined,
    year: date ? date.getFullYear() : undefined
  };
};

/**
 * Custom date picker component that consists of three dropdowns.
 */
class DatePicker extends React.Component {
  constructor(props) {
    super(props);

    this.state = { ...structureDate(this.props.value), errorText: '' };
  }

  select(field, value) {
    this.setState({
      [field]: value
    });

    const { year, month, day } = {
      ...this.state,
      [field]: value
    };
    const date = new Date(year, month, day);

    // Verify we have a completed date
    let validDate = !isNaN(date);

    // Run validation if applicable
    if (validDate && this.props.validate) {
      const validation = this.props.validate(date);
      this.setState({
        errorText: validation
      });
      validDate = !validation;
    }

    // Submit date via onChange event if applicable
    if (validDate && this.props.onChange) {
      this.props.onChange(date.getTime());
    }
  }

  componentWillReceiveProps(props) {
    if (props.value) {
      this.setState({
        ...structureDate(props.value)
      });
    }
  }

  createPicker(field, onMobile) {
    const displayLabel = this.props.order[0] === field;
    const displayError = this.props.order[onMobile ? 2 : 0] === field;

    const values = dateHelper.getValues(
      field,
      structureDate(this.props.minDate),
      structureDate(this.props.maxDate),
      this.state,
      this.props.sortYearAscending
    );
    const displays = dateHelper.getDisplays(field, !!this.props.short, values);

    const hintText =
      (this.props.hintText && this.props.hintText[field]) || defaultFieldNames[field];

    const key = `select-${field}`;

    const label =
      (displayLabel ? this.props.floatingLabelText : undefined) ||
      (onMobile ? undefined : hintText);

    const style = {
      width: '100%',
      maxWidth: onMobile
        ? '100%'
        : (this.props.maxWidths && this.props.maxWidths[field]) || defaultMaxWidths[field]
    };

    const err = this.state.errorText ? (displayError ? this.state.errorText : emptyLabel) : '';

    return (
      <SelectField
        labelStyle={{ paddingLeft: 0 }}
        underlineStyle={{ margin: '-1px 24px -1px 0' }}
        className={key}
        key={key}
        onChange={(_, __, value) => this.select(field, value)}
        value={this.state[field]}
        hintText={hintText}
        style={style}
        maxHeight={300}
        floatingLabelText={label}
        errorText={err}
      >
        {values.map((x, i) => (
          <MenuItem key={`${field}-${x}`} value={x} primaryText={displays[i]} />
        ))}
      </SelectField>
    );
  }

  render() {
    const onMobile = this.props.width <= SMALL;
    const style = {
      ...styles.row,
      flexDirection: onMobile ? 'column' : 'row'
    };
    return (
      <div style={this.props.style}>
        <div style={style}>
          {this.props.order.map((field) => this.createPicker(field, onMobile))}
        </div>
      </div>
    );
  }
}

DatePicker.defaultProps = {
  onChange: () => {
    // ... no-op
  },
  validate: () => '',
  order: ['month', 'day', 'year'],
  minDate: new Date(1900, 0, 1),
  maxDate: new Date(2100, 11, 31),
  sortYearAscending: false
};

export default withWidth({ mediumWidth: 512 })(DatePicker);



// WEBPACK FOOTER //
// ./src/components/date-picker/index.js